/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ReturnTypeEnum {
    NUMBER = 'NUMBER',
    CURRENCY = 'CURRENCY',
    PERCENT = 'PERCENT',
    SHORT_TEXT = 'SHORT_TEXT',
    LONG_TEXT = 'LONG_TEXT',
    CHECKBOX = 'CHECKBOX',
    YES_OR_NO = 'YES_OR_NO',
    DATE = 'DATE',
    DOCUMENT = 'DOCUMENT',
    SINGLE_SELECT = 'SINGLE_SELECT',
    MULTI_SELECT = 'MULTI_SELECT',
    SERIES = 'SERIES',
}
